import gql from 'graphql-tag';

export default gql`
  mutation addGroupRole($groupRole: GroupRoleInput!) {
    addGroupRole(groupRole: $groupRole) {
      _id
    }
  }
`;
